module.exports = __webpack_public_path__ + "static/center-3927521d56eb813cb63a31479ceb2ed5.jpg";